import {
  FunctionComponent,
  MouseEventHandler,
  useCallback,
  useRef,
  useState,
} from "react";

import useOnClickOutside from "@src/common/hooks/useOnClickOutside";
import { useIsMobile } from "@src/common/styles/media";
import { ReactComponent as KebabLogo } from "@src/modules/shared/components/KebabMenu/icons/kebab.svg";
import {
  KebabBackground,
  KebabMenuWrapper,
  KebabOptionsWrapper,
} from "@src/modules/shared/components/KebabMenu/KebabMenu.components";

interface Props {
  isLastInRow?: boolean;
  hasRelativePosition?: boolean;
  isPositionDown?: boolean;
}

const KebabMenu: FunctionComponent<Props> = ({
  isLastInRow = false,
  hasRelativePosition = false,
  children,
  isPositionDown,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const isMobile = useIsMobile();
  const optionsRef = useRef<HTMLDivElement>(null);
  const toggle: MouseEventHandler<HTMLDivElement> = useCallback(
    (event) => {
      event.stopPropagation();
      setIsVisible((prev) => !prev);
    },
    [setIsVisible],
  );
  const setHidden = useCallback(() => setIsVisible(false), [setIsVisible]);
  useOnClickOutside(optionsRef, setHidden);

  return (
    <KebabMenuWrapper
      ref={optionsRef}
      onClick={toggle}
      hasRelativePosition={hasRelativePosition}
      data-cy="kebab-menu"
    >
      <KebabLogo />
      {isMobile && <KebabBackground isVisible={isVisible} />}
      <KebabOptionsWrapper
        isVisible={isVisible}
        isLastInRow={isLastInRow}
        isPositionDown={isPositionDown}
      >
        {children}
      </KebabOptionsWrapper>
    </KebabMenuWrapper>
  );
};

export default KebabMenu;
